export function emptyOrNull(arr) {
  if(!arr) return true;
  if(arr && arr.length === 0) return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/common.js